(ns frontend.components.inputs.wysiwyg
  (:require
   [common.schema.entities.survey.survey-text-variables :as survey-text-variables]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [ui.components.rich-text.tiptap :as tiptap]
   [ui.components.tiptap.view :as mention-tiptap]))

(defn mention-variable-ids
  [variable-source]
  (survey-text-variables/variable-ids-for-source variable-source))

(defn render
  [dom-atom args]
  (let [{:keys [value on-focus! on-blur! on-change! link?]} args
        edit-value (or (:temp-value @dom-atom) value)
        resolved-blur-value (or (:temp-value @dom-atom) edit-value value)
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value :wysiwyg-updates?))]
    [tiptap/editor
     {:value     edit-value
      :on-change (fn [value]
                   (swap! dom-atom assoc
                          :temp-value value
                          :wysiwyg-updates? true)
                   (when on-change!
                     (on-change! nil value)))
      :on-focus  (fn [e]
                   (when on-focus!
                     (on-focus! e)))
      :on-blur   (fn [e]
                   (when (fn? on-blur!)
                     (on-blur! e resolved-blur-value clear-state!)))
      :link?     link?
      :show-alignment? true
      :show-block-type? false
      :inline-options [:bold :italic :underline]}]))

(defmethod editor :editor.type/wysiwyg
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                                                                ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Wysiwyg"
      :component-did-mount    (fn [_]
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    (when-let [dom-node (:input-dom-node @dom-atom)]
                                                      (.focus dom-node)))))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc :temp-value))))      ;; save complete -> reset temp state
                                (when set-save!
                                  (set-save! (fn [_]
                                               (when-let [dom-node (:input-dom-node @dom-atom)]
                                                 (.blur dom-node))))))
      :component-will-unmount (fn [
                                   ;; clear atom - dispose
                                   ])
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod editor :editor.type/richtext-mention
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]
    (r/create-class
     {:display-name           "RichtextMention"
      :component-did-mount    (fn [_]
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    true)))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc :temp-value))))
                                (when set-save!
                                  (set-save! (fn [_]
                                               true))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :temp-value))
      :reagent-render         (fn [{:keys [value on-blur! on-change! class-name]
                                    :ui/keys [variable-source]}]
                                (let [edit-value (or (:temp-value @dom-atom) value)
                                      clear-state! (fn []
                                                     (swap! dom-atom dissoc :temp-value))]
                                  [mention-tiptap/view
                                   {:value        edit-value
                                    :class        (fu/cs "min-h-[200px]" class-name)
                                    :trigger-char "{"
                                    :item-texts   (mention-variable-ids variable-source)
                                    :on-change    (fn [_text html _json]
                                                    (swap! dom-atom assoc :temp-value html)
                                                    (when on-change!
                                                      (on-change! nil html)))
                                    :on-blur      (fn [e]
                                                    (when (fn? on-blur!)
                                                      (on-blur! e edit-value clear-state!)))}]))})))

(defmethod display-string :editor.type/wysiwyg
  [args]
  (:value args))

(defmethod display-string :editor.type/richtext-mention
  [args]
  (display-string (assoc args :editor/type :editor.type/wysiwyg)))

(defmethod viewer :editor.type/wysiwyg
  [_]
  (r/create-class
   {:display-name   "Wysiwyg/viewer"
    :reagent-render (fn [args]
                      [tiptap/viewer
                       {:class "preview preview-wysiwyg"
                        :value (fu/sanitize-html (:value args))}])}))

(defmethod viewer :editor.type/richtext-mention
  [args]
  [viewer (assoc args :editor/type :editor.type/wysiwyg)])
